var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompProjects(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2932_431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.95 10.45C19.3083 10.45 19.6672 10.3133 19.9399 10.0399L23.9 6.07979C24.4469 5.53357 24.4469 4.64697 23.9 4.1001C23.3531 3.55322 22.4658 3.55322 21.9203 4.1001L17.9602 8.06018C17.4133 8.6064 17.4133 9.49365 17.9602 10.0399C18.2329 10.3134 18.5918 10.45 18.95 10.45Z",
    fill: "#22C55E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6001 12.6001H21.0001C20.2269 12.6001 19.6001 13.227 19.6001 14.0001C19.6001 14.7733 20.2269 15.4001 21.0001 15.4001H26.6001C27.3733 15.4001 28.0001 14.7733 28.0001 14.0001C28.0001 13.227 27.3733 12.6001 26.6001 12.6001Z",
    fill: "#22C55E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.96 19.9396L21.9201 23.8997C22.1928 24.1732 22.5517 24.3099 22.9099 24.3099C23.2681 24.3099 23.6263 24.1732 23.8998 23.8997C24.4467 23.3529 24.4467 22.4663 23.8998 21.92L19.9397 17.96C19.3935 17.4131 18.5062 17.4131 17.96 17.96C17.4131 18.5061 17.4131 19.3934 17.96 19.9396Z",
    fill: "#22C55E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6001 26.6001C12.6001 27.3733 13.227 28.0001 14.0001 28.0001C14.7733 28.0001 15.4001 27.3733 15.4001 26.6001V21.0001C15.4001 20.2269 14.7733 19.6001 14.0001 19.6001C13.227 19.6001 12.6001 20.2269 12.6001 21.0001V26.6001Z",
    fill: "#22C55E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.07979 23.8997L10.0399 19.9396C10.5867 19.3934 10.5867 18.5062 10.0399 17.96C9.49365 17.4131 8.6064 17.4131 8.06018 17.96L4.1001 21.92C3.55322 22.4663 3.55322 23.3529 4.1001 23.8997C4.37354 24.1732 4.73174 24.3099 5.08994 24.3099C5.44814 24.3099 5.807 24.1732 6.07979 23.8997Z",
    fill: "#22C55E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 14.0001C0 14.7733 0.626828 15.4001 1.4 15.4001H7C7.77312 15.4001 8.4 14.7733 8.4 14.0001C8.4 13.227 7.77312 12.6001 7 12.6001H1.4C0.626828 12.6001 0 13.227 0 14.0001Z",
    fill: "#22C55E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.07979 4.1001C5.53428 3.55322 4.64697 3.55322 4.1001 4.1001C3.55322 4.64697 3.55322 5.53357 4.1001 6.07979L8.06018 10.0399C8.33291 10.3133 8.69182 10.45 9.05003 10.45C9.40823 10.45 9.76714 10.3133 10.0399 10.0399C10.5867 9.49365 10.5867 8.6064 10.0399 8.06018L6.07979 4.1001Z",
    fill: "#22C55E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 8.4C14.7733 8.4 15.4001 7.77312 15.4001 7V1.4C15.4001 0.626828 14.7733 0 14.0001 0C13.227 0 12.6001 0.626828 12.6001 1.4V7C12.6001 7.77312 13.227 8.4 14.0001 8.4Z",
    fill: "#22C55E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2932_431"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompProjects);
export default __webpack_public_path__ + "static/media/CompProjects.adf6cb2ba7b59942d403290a7f27579f.svg";
export { ForwardRef as ReactComponent };